import { render, staticRenderFns } from "./ConsumptionDataExchangeEADBuchholz.vue?vue&type=template&id=4e436f15&lang=pug&"
import script from "./ConsumptionDataExchangeEADBuchholz.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeEADBuchholz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports